module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-2": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Completa los datos")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "mr-3": "",
      "text-xs-left": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label-text": "Nombre"
    },
    model: {
      value: (_vm.seller.name),
      callback: function($$v) {
        _vm.seller.name = $$v
      },
      expression: "seller.name"
    }
  }), _vm._v(" "), (!_vm.$v.seller.name.required) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\tEl nombre es requerido.\n\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "mr-3": "",
      "text-xs-left": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label-text": "Apellidos"
    },
    model: {
      value: (_vm.seller.lastName),
      callback: function($$v) {
        _vm.seller.lastName = $$v
      },
      expression: "seller.lastName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "mr-3": "",
      "text-xs-left": ""
    }
  }, [_c('type-document-input', {
    attrs: {
      "labelText": "Identificación del empleado",
      "placeholder": "Identificación",
      "search": true
    },
    model: {
      value: (_vm.seller.entity),
      callback: function($$v) {
        _vm.seller.entity = $$v
      },
      expression: "seller.entity"
    }
  }), _vm._v(" "), (_vm.$v.customer.entity.documentType && _vm.$v.customer.entity.documentType.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\tEl tipo de indentificación es requerida.\n\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.$v.seller.entity.numDocument.required) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\tLa indentificación es requerida.\n\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "mr-3": "",
      "text-xs-left": ""
    }
  }, [_c('select-date', {
    attrs: {
      "icon": "event",
      "label-text": "Fecha de nacimiento"
    },
    model: {
      value: (_vm.seller.dateBirth),
      callback: function($$v) {
        _vm.seller.dateBirth = $$v
      },
      expression: "seller.dateBirth"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "mr-3": "",
      "text-xs-left": ""
    }
  }, [_c('input-text', {
    attrs: {
      "type": "email",
      "label-text": "Correo electrónico"
    },
    model: {
      value: (_vm.seller.email),
      callback: function($$v) {
        _vm.seller.email = $$v
      },
      expression: "seller.email"
    }
  }), _vm._v(" "), (!_vm.$v.seller.email.required) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\tEl correo es requerido\n\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.$v.seller.email.email) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\tcorreo inválido\n\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "mr-3": "",
      "text-xs-left": ""
    }
  }, [_c('input-text', {
    attrs: {
      "type": "tel",
      "label-text": "Teléfono"
    },
    model: {
      value: (_vm.seller.phone),
      callback: function($$v) {
        _vm.seller.phone = $$v
      },
      expression: "seller.phone"
    }
  }), _vm._v(" "), (!_vm.$v.seller.phone.minLength) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\tmínimo 6 dígitos\n\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.$v.seller.phone.maxLength) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\tmáximo 11 dígitos\n\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "autocomplete": "",
      "label": "",
      "labelText": "País",
      "itemText": "name",
      "itemValue": "id",
      "placeholder": "País",
      "items": _vm.countries
    },
    model: {
      value: (_vm.seller.country),
      callback: function($$v) {
        _vm.seller.country = $$v
      },
      expression: "seller.country"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "label": "",
      "labelText": "Género",
      "itemText": "name",
      "itemValue": "id",
      "placeholder": "Género",
      "items": _vm.genders
    },
    model: {
      value: (_vm.seller.gender),
      callback: function($$v) {
        _vm.seller.gender = $$v
      },
      expression: "seller.gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "label": "",
      "labelText": "Estado Civil",
      "itemText": "name",
      "itemValue": "id",
      "placeholder": "Estado Civil",
      "items": _vm.civilStatus
    },
    model: {
      value: (_vm.seller.civilStatus),
      callback: function($$v) {
        _vm.seller.civilStatus = $$v
      },
      expression: "seller.civilStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "mr-3": "",
      "text-xs-left": ""
    }
  }, [_c('select-date', {
    attrs: {
      "icon": "event",
      "label-text": "Fecha de ingreso"
    },
    model: {
      value: (_vm.seller.dateHealing),
      callback: function($$v) {
        _vm.seller.dateHealing = $$v
      },
      expression: "seller.dateHealing"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "mr-3": "",
      "text-xs-left": ""
    }
  }, [_c('input-text', {
    attrs: {
      "readonly": "",
      "label-text": "Venta Total"
    },
    model: {
      value: (_vm.seller.totalSales),
      callback: function($$v) {
        _vm.seller.totalSales = _vm._n($$v)
      },
      expression: "seller.totalSales"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "d-flex": "",
      "justify-start": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-save white--text",
    attrs: {
      "disabled": _vm.$v.$invalid
    },
    on: {
      "click": _vm.saveEmployee
    }
  }, [_vm._v("\n\t\t\t\tGuardar\n\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6955f958","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/sellers/New.vue
// module id = 1658
// module chunks = 4